import _keys from 'lodash/keys';

export const getAvailableFeatureOptions = (
  totalFeatures,
  existingFeatures,
  currentFeature,
) =>
  _keys(totalFeatures)
    .filter(
      id =>
        !existingFeatures.find(f => f.feature === id) || id === currentFeature,
    )
    .map(id => ({
      label: totalFeatures[id].name,
      value: id,
    }));

export const getSuggestions = (feature, featuresMap) => {
  if (!feature) {
    return [];
  }
  const availableValues = featuresMap[feature].available_values;

  if (availableValues) {
    return availableValues.map(value => value.toString());
  }
  return [];
};

export const getFilteredSuggestions = (
  feature,
  featuresMap,
  inputValue = '',
) => {
  const suggestedValues = getSuggestions(feature, featuresMap);
  if (!suggestedValues) {
    return [];
  }
  return suggestedValues.filter(
    state => state.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
  );
};

export default getAvailableFeatureOptions;
